import { Box, Divider, styled, Typography } from '@mui/material'
import {
  AuditLogHeaderActions,
  AuditLogHeaderActionsVariant,
} from 'pages/insights/auditLog/components/AuditLogHeaderActions'
import { ConsentTabAggregateInfo } from 'pages/insights/auditLog/components/consentsTab/components/ConsentTabAggregateInfo'
import { ConsentTabIdentifiers } from 'pages/insights/auditLog/components/consentsTab/components/ConsentTabIdentifiers'
import { ConsentTabPurposes } from 'pages/insights/auditLog/components/consentsTab/components/ConsentTabPurposes'
import { ConsentTabSystems } from 'pages/insights/auditLog/components/consentsTab/components/ConsentTabSystems'
import { useAuditLogContext } from 'pages/insights/auditLog/context/AuditLogContext'

const ConsentsTabBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
})

export const AuditLogConsentTab: React.FC = () => {
  const { queries } = useAuditLogContext()
  return (
    <ConsentsTabBox>
      <Typography variant="h2" pt={2}>
        "{queries.identifierSearch}" Most Recent Consent Record
      </Typography>
      <AuditLogHeaderActions variant={AuditLogHeaderActionsVariant.Consent} />
      <ConsentTabAggregateInfo />
      <Divider sx={{ mt: 2 }} />
      <ConsentTabPurposes />
      <Divider sx={{ mt: 4 }} />
      <ConsentTabIdentifiers />
      <Divider sx={{ mt: 4 }} />
      <ConsentTabSystems />
    </ConsentsTabBox>
  )
}
